export default __webpack_public_path__ + "static/media/guard2.860ed19a.jpg";